import { axiosInstance } from "../services/axiosInstance";
import catchAsync from "../utils/catchAsync";
export const ListClients = catchAsync(
  async (sortBy = null, searchQuery = "",page) => {
    let query = `?by_latest=${1}&by_appointments=${0}`;

    if (sortBy === "appointments") {
      query = `?by_latest=${0}&by_appointments=${1}`;
    }

    const searchParam = searchQuery ? `?search=${searchQuery}` : "";

    const url = sortBy
      ? `salon/client/profiles/filter${query}${searchParam}`
      : `salon/client/profiles${searchParam}`;

    return axiosInstance.get(url);
  }
);

export const addClient = catchAsync(async (body) => {
  const data = await axiosInstance.post(`salon/client/profiles`, body);
  return data;
});
export const updateClient = catchAsync(async (body) => {
  const data = await axiosInstance.put(
    `salon/client/profiles/${body.id}`,
    body
  );
  return data;
});

export const uploadCSV = catchAsync(async (body) => {
  const data = await axiosInstance.post("salon/client/profiles/import", body, {
    headers: {
      "Content-Type": "multipart/form-data", // Set the correct Content-Type for FormData
    },
  });
  return data;
});

export const addClientCalendarModal = catchAsync((body) => {
  return axiosInstance.post(`salon/client/profiles`, body);
});
export const getClients = catchAsync((search = null) => {
  let query = "";
  if (search) {
    query = `?search=${search}`;
  }

  return axiosInstance.get(`salon/client/profiles${query}`);
});
export const getClientDetails = catchAsync((id) => {
  return axiosInstance.get(`salon/client/profiles/${id}`);
});
export const deleteClient = catchAsync(async (clientId) => {
  const { data } = await axiosInstance.delete(
    `salon/client/profiles/${clientId}`
  );
  return data;
});
